import _ from 'lodash';
import { selectMetricsModalOption } from 'modals/modal-options-factory';
import { DefinitionLevels, SettingValues } from '@linearb/linjs-common';
import moment from 'moment';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import {
  PREVIOUS_PERIODS,
  NUM_METRICS_TO_SELECT,
  TREND_DIRECTIONS,
  UNIT_TYPES
} from './GroupMetricsTable.consts';

export const getCellName = (metricName, availableMetricsWidgetsByName) => {
  return _.get(
    availableMetricsWidgetsByName[metricName],
    'name',
    ''
  ).toUpperCase();
};

/* istanbul ignore next */
const getMetricsTableColumn = (metricNames, availableMetricsWidgets) => {
  return availableMetricsWidgets
    .filter(metric => [...metricNames].includes(metric.name))
    .map(metric => _.get(metric, 'metrics[0].name'));
};

/* istanbul ignore next */
const onDone = async (
  selectedMetricsNames,
  toggleModal,
  availableMetricsWidgets,
  setTableMetricsNames,
  updateSetting,
  teamId
) => {
  const metricsToAddToTable = getMetricsTableColumn(
    selectedMetricsNames,
    availableMetricsWidgets
  );
  try {
    await updateSetting(
      SettingValues.GROUP_DASHBOARD_METRICS_TABLE_COLS,
      metricsToAddToTable,
      DefinitionLevels.TEAM,
      teamId,
      true
    );

    setTableMetricsNames(metricsToAddToTable);
  } catch (e) {}

  toggleModal();
};

/* istanbul ignore next */
export const handleEditTableMetricsClick = (
  toggleModal,
  availableMetricsWidgets,
  setTableMetricsNames,
  initialState,
  updateSetting,
  selectedGroupId
) => {
  toggleModal(
    selectMetricsModalOption({
      initialState,
      metrics: availableMetricsWidgets,
      onDone: selectedMetricsNames =>
        onDone(
          selectedMetricsNames,
          toggleModal,
          availableMetricsWidgets,
          setTableMetricsNames,
          updateSetting,
          selectedGroupId
        ),
      isDisableBtn: selectedMetrics =>
        selectedMetrics.size !== NUM_METRICS_TO_SELECT,
      shouldDisableSelection: selectedMetrics =>
        selectedMetrics.size === NUM_METRICS_TO_SELECT,
      instructions: 'Please select 4 metrics.'
    })
  );
};

export const getTableColsTitlesInitialState = (
  availableMetricsWidgets = [],
  tableMetricsNames
) => {
  return availableMetricsWidgets
    .filter(widget =>
      tableMetricsNames.includes(_.get(widget, 'metrics[0].name'))
    )
    .map(widget => _.get(widget, 'name'));
};

export const getLastPeriodDates = (selectedPeriodKey, prevIteration) => {
  if (PREVIOUS_PERIODS[selectedPeriodKey] === undefined) {
    return null;
  }
  if (selectedPeriodKey === PREVIOUS_PERIODS.ITERATIONS.periodKey) {
    return {
      from: prevIteration?.start_date,
      to: prevIteration?.end_date
    };
  }
  return {
    from: moment(PREVIOUS_PERIODS[selectedPeriodKey].after).format(
      SEARCH_DATE_FORMAT
    ),
    to: moment(PREVIOUS_PERIODS[selectedPeriodKey].before).format(
      SEARCH_DATE_FORMAT
    )
  };
};

export const getTrendDirectionAndPercentChangePerMetric = (
  DataCurrentPriod,
  DataLastPriod,
  metricsNames = [],
  metricsWidgetsByName
) => {
  const trendDirection = {};
  const percentChange = {};

  metricsNames.forEach(metricName => {
    let diff = 0;
    const metricCurrentValue = DataCurrentPriod[metricName];
    const metricPreviuosValue = DataLastPriod[metricName];

    if (!!metricCurrentValue && !!metricPreviuosValue) {
      diff = metricCurrentValue - metricPreviuosValue;
      if (diff) {
        const unitType = _.get(metricsWidgetsByName[metricName], 'unitType');
        percentChange[metricName] = getPercentChange(
          metricPreviuosValue,
          diff,
          unitType
        );
      }
    }
    if (diff > 0) {
      trendDirection[metricName] = TREND_DIRECTIONS.UP;
    }
    if (diff < 0) {
      trendDirection[metricName] = TREND_DIRECTIONS.DOWN;
    }
    if (
      diff === 0 ||
      _.isNil(metricCurrentValue) ||
      _.isNil(metricPreviuosValue)
    ) {
      trendDirection[metricName] = TREND_DIRECTIONS.SAME;
      percentChange[metricName] = '';
    }
  });

  return { trendDirection, percentChange };
};

const getPercentChange = (
  metricPreviuosValue,
  diffFromLastPeriod,
  unitType
) => {
  if (unitType === UNIT_TYPES.PERCENTAGE) {
    return `${_.round(Math.abs(diffFromLastPeriod), 2)}%`;
  }
  if (unitType) {
    return `${+(
      Math.abs(diffFromLastPeriod / metricPreviuosValue) * 100
    ).toFixed(2)}%`;
  }
};

export const getIconName = direction => {
  if (direction === TREND_DIRECTIONS.UP) {
    return 'ArrowUp';
  }
  if (direction === TREND_DIRECTIONS.DOWN) {
    return 'ArrowDown';
  }
  return null;
};

export const getShouldShowTrend = (
  value,
  trendIconName,
  previuosValue,
  lastPeriodDates
) => {
  return value !== '-' && trendIconName && previuosValue && lastPeriodDates;
};
